var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "academicConsultantJudgment",
      attrs: {
        inline: false,
        model: _vm.academicConsultantJudgment,
        "label-width": "160px"
      }
    },
    [
      _vm.daysLeftEvaluate
        ? _c(
            "div",
            [
              _c(
                "el-form-item",
                { attrs: { label: "Ημερ. ανάθεσης:" } },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(
                        this.application.applicationHistory[
                          this.application.applicationHistory.length - 1
                        ].date.substring(0, 10)
                      ) +
                      "\n    "
                  ),
                  _c("el-alert", {
                    attrs: {
                      type: "warning",
                      title:
                        _vm.daysLeftEvaluate +
                        " μέρες απομένουν για να υποβληθεί η αξιολόγηση.",
                      "show-icon": "",
                      closable: false
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.application.grade_description
        ? _c("el-form-item", { attrs: { label: "Βαθμός" } }, [
            _vm._v("\n    " + _vm._s(_vm.application.grade) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.application.grade_description
        ? _c("el-form-item", { attrs: { label: "Χαρακτηρισμός" } }, [
            _vm._v(
              "\n    " + _vm._s(_vm.application.grade_description) + "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("proposals"),
          _vm._v(" "),
          _c("internalComments"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Εσωτερικό Σχόλιο:" } },
            [
              _c("el-input", {
                staticClass: "commentText",
                attrs: {
                  type: "textarea",
                  placeholder: "Εισάγετε εσωτερικό σχόλιο",
                  size: "100",
                  autosize: { minRows: 4, maxRows: 10 }
                },
                on: { change: _vm.modifyInternalComment },
                model: {
                  value: _vm.academicConsultantJudgment.internalComment,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.academicConsultantJudgment,
                      "internalComment",
                      $$v
                    )
                  },
                  expression: "academicConsultantJudgment.internalComment"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Εισήγηση:" } },
            [
              _c("el-input", {
                staticClass: "commentText",
                attrs: {
                  type: "textarea",
                  placeholder: "Εισάγετε την εισήγησή σας εδώ",
                  size: "100",
                  autosize: { minRows: 4, maxRows: 10 }
                },
                on: { change: _vm.modifyProposal },
                model: {
                  value: _vm.academicConsultantJudgment.proposal,
                  callback: function($$v) {
                    _vm.$set(_vm.academicConsultantJudgment, "proposal", $$v)
                  },
                  expression: "academicConsultantJudgment.proposal"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary", round: "" },
              on: {
                click: function($event) {
                  _vm.tempSave()
                }
              }
            },
            [_vm._v("Αποθήκευση")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "danger",
                round: "",
                disabled: !_vm.isValidForm
              },
              on: {
                click: function($event) {
                  _vm.finalSave()
                }
              }
            },
            [_vm._v("Ολοκλήρωση")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63a2ee62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a2ee62","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/AcademicConsultantJudgment.vue
// module id = null
// module chunks = 